import { render, staticRenderFns } from "./kindChooseViewzl.vue?vue&type=template&id=0c97b0e9&scoped=true"
import script from "./kindChooseViewzl.vue?vue&type=script&lang=js"
export * from "./kindChooseViewzl.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewzl.vue?vue&type=style&index=0&id=0c97b0e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97b0e9",
  null
  
)

export default component.exports